module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "global_tws_blackbg_v2.dc0b55cb.png";